import { GhostAPI } from '@tryghost/content-api';
import React, { useEffect, useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import * as contentful from 'contentful';
import _isEmpty from 'lodash/isEmpty';
import { AppContext } from './context/app-context';
import withContentApi from './hoc/withContentApi';
import HomePage from './pages/homepage';
import HeaderMeta from './components/header-meta';
import { IContentFulRaw } from './model/contentful-model';
import { LoadScript } from '@react-google-maps/api';
import Footer from './components/footer';
import Header from './components/header';

interface IProps {
  api?: GhostAPI;
}

const client = contentful.createClient({
  // This is the space ID. A space is like a project folder in Contentful terms
  space: process.env.REACT_APP_CONTENT_SPACE || '',
  // This is the access token for this space. Normally you get both ID and the token in the Contentful web app
  accessToken: process.env.REACT_APP_CONTENT_API || '',
  host: process.env.REACT_APP_PROXY_URL || '',
});

const sessionKey = `${new Date().toLocaleDateString()}_cache_data`;

const App: React.FC<IProps> = ({ api }) => {
  const [rawContentFul, setRawContentFul] = useState<IContentFulRaw>();
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setLoading(_isEmpty(rawContentFul));
  }, [rawContentFul]);

  useEffect(() => {
    if (sessionStorage) {
      const data = sessionStorage.getItem(sessionKey);

      if (data) {
        console.log('====using cache');
        setRawContentFul(JSON.parse(data));
      } else {
        console.log('====request online data');
        client.getEntries().then(resData => {
          // @ts-ignore
          setRawContentFul(resData);
          sessionStorage.setItem(sessionKey, JSON.stringify(resData));
        });
      }
    }
  }, []);

  return (
    <>
      <HeaderMeta />
      <AppContext.Provider value={{
        rawContentFul,
      }}>
        <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_API_KEY || ''}>
        <div className={
          `flex flex-col w-full min-h-screen ${
            location.pathname === '/glossary' ? '' : 'overflow-x-hidden'
          }`
        }>
          <div className='flex flex-col flex-grow w-full'>
            <div className='relative max-w-6xl mx-auto w-full'>
              <Header />
            </div>
            <div className='lg:px-0 flex-grow'>
              <Routes>
                <Route path='/' element={<HomePage />} />
              </Routes>
            </div>
          </div>
          <footer className='w-full'>
            <div className='flex flex-col flex-grow px-0 lg:px-16 xl:px-0 max-w-6xl mx-auto w-full'>
              <Footer />
            </div>
          </footer>
        </div>
        </LoadScript>
        {
          loading && (
            <div className='w-full h-full fixed block top-0 left-0 bg-white opacity-75 z-50'>
              <span className='text-green-500 opacity-75 top-1/2 my-0  block relative w-full h-0 '>
                <svg fill='none' className='h-100 w-100 mx-auto animate-spin' viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'>
                  <path clipRule='evenodd'
                    d='M15.165 8.53a.5.5 0 01-.404.58A7 7 0 1023 16a.5.5 0 011 0 8 8 0 11-9.416-7.874.5.5 0 01.58.404z'
                    fill='currentColor' fillRule='evenodd' />
                </svg>
              </span>
            </div>
          )
        }
      </AppContext.Provider>
    </>

  )
}

export default withContentApi<IProps>(App);
